import axios from 'axios'
import { useAuthStore } from '../../zustand/authentication/use-auth-store'
import rules from '../../../proxyConfig/rules'
import { rewritePath } from '../../utils/pathRewriter'

const api = axios.create({
  baseURL: rules.target,
  headers: {
    accept: 'application/json, text/plain, */*',
    'X-Platform': 'WEB'
  }
})

api.CancelToken = axios.CancelToken
api.isCancel = axios.isCancel
// Interceptor para incluir os headers dinâmicos
api.interceptors.request.use((config) => {
  const { path, baseURL } = rewritePath({
    path: config.url,
    baseURL: self.location.origin
  })

  config.baseURL = baseURL
  config.url = path

  // Verifica se o header Authorization já existe
  const hasCustomAuthorization = config.headers && config.headers.Authorization

  // Se não existir um Authorization customizado, adicionamos o do auth store
  if (!hasCustomAuthorization) {
    const token = useAuthStore.getState().token
    if (token && config.headers) {
      config.headers.Authorization = `${token.token_type} ${token.access_token}`
    }
  }
  return config
})

export default api
